/**
 * DiyResourcesSection — Landing page "Free guides for DIY landlords" block.
 * Extracted from Landing.jsx in the components-split refactor.
 *
 * Renders a 3-column grid (responsive) of resource cards from the
 * `DIY_RESOURCES` data array (imported from the landing data module so
 * Landing.jsx no longer owns the section markup).
 */
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DIY_RESOURCES } from "@/data/landing";

export default function DiyResourcesSection() {
  return (
    <section id="resources" className="py-16 md:py-24 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.22em] uppercase font-bold text-emerald-700">DIY landlord resources</div>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Free guides for DIY Canadian landlords.
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            Repair walkthroughs, RTA cheatsheets, CRA tax explainers, screening guides — the long-form library we wish every new landlord had on day one.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10" data-testid="diy-resources">
          {DIY_RESOURCES.map((r, i) => {
            const Icon = r.icon;
            return (
              <Link key={i} to={r.href} data-testid={`diy-resource-${i}`}
                className="group block bg-white border border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all rounded-2xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                    <Icon className="w-5 h-5"/>
                  </div>
                  <span className="text-[10px] tracking-[0.18em] uppercase font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-full">{r.tag}</span>
                </div>
                <h3 className="font-display text-lg font-bold text-slate-950 group-hover:text-emerald-700 transition-colors">{r.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed mt-2">{r.body}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-emerald-700 group-hover:gap-2.5 transition-all">Read the guide <ArrowRight className="w-4 h-4"/></div>
              </Link>
            );
          })}
        </div>
        <div className="mt-8 text-center">
          <Link to="/blog" data-testid="diy-resources-more"
            className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 hover:text-emerald-800 hover:underline">
            Browse all guides on the blog <ArrowRight className="w-4 h-4"/>
          </Link>
        </div>
      </div>
    </section>
  );
}
